import Select from 'react-select';
import { tailwindSelectStyles } from './reactSelectStyles';

const SelectInput = ({
  options = [],
  value = null,
  onChange,
  placeholder = 'Select...',
  isSearchable = true,
  isClearable = true,
  noOptionsMessage = () => 'No options found',
  className = '',
}) => {
  return (
    <div className={`w-full ${className}`}>
      <Select
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isClearable={isClearable}
        styles={tailwindSelectStyles}
        classNamePrefix="react-select"
        noOptionsMessage={noOptionsMessage}
        theme={(theme) => ({
          ...theme,
          borderRadius: 8,
          colors: {
            ...theme.colors,
            primary25: '#eff6ff', // hover
            primary: '#3b82f6',   // main blue
          },
        })}
      />
    </div>
  );
};

export default SelectInput;

